import styled from "@emotion/styled"
import { get } from "lodash"
import React from "react"
import tw from "twin.macro"
import Picture from "./Picture"
import VideoEmbed from "./VideoEmbed"

const StyledBanner = styled.div`
  ${tw`flex items-center justify-center flex-col`}
  height: 480px;
  position: relative;
`

const Image = styled(Picture)`
  ${tw`w-full h-full absolute inset-0`}
`

const Video = styled(VideoEmbed)`
  ${tw`w-full h-full absolute inset-0`}
`

const Banner = ({ banner }) => {
  const media =
    get(banner, "elements.media.value[0].elements.image.value[0]") ||
    get(banner, "elements.media.value[0]")
  const mediaType = get(banner, "elements.media.value[0].system.type")
  const imageAltText = get(
    banner,
    "elements.media.value[0].elements.alt_text.value"
  )
  const focalPoint = get(
    banner,
    "elements.media.value[0].elements.focal_point.value"
  )

  return (
    <StyledBanner>
      {mediaType === `video_embed` && (
        <Video
          video={media}
          playInModal={false}
          cover={true}
          autoplay={true}
          muted={true}
          playsinline={true}
          loop
        />
      )}
      {mediaType === `image` && (
        <Image
          image={media}
          cropWidth={1600}
          cropRatio={0.4}
          cover={true}
          focalPoint={focalPoint}
          alt={imageAltText}
        />
      )}
    </StyledBanner>
  )
}

export default Banner
